import { Amounts } from '@/components/Amounts';
import { BasketExpressCheckout } from '@/components/BasketExpressCheckout';
import { Button } from '@/components/Button';
import { DiscountCodeEntry } from '@/components/DiscountCodeEntry';
import { DiscountTags } from '@/components/DiscountTags';
import { InlinedAside } from '@/components/InlinedAside';
import { Promotions } from '@/components/Promotions';
import { ButtonVariant } from '@/constants';
import { useCheckout } from '@/contexts/checkoutContext';
import { usePageData } from '@/contexts/pageContext';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { testIsFree } from '@/utils/testIsFree';
import * as Styled from './BasketDetails.styled';

export const BasketDetails = () => {
  const {
    checkoutData: { amounts, discountCode },
  } = useCheckout();
  const { cartServiceMessage, isQuickPayEnabled, urls } = usePageData();
  const isWideScreen = useMediaQuery('(width >= 48rem)');

  return (
    <Styled.OuterWrapper>
      <Styled.DetailsHeading level={3}>Basket details</Styled.DetailsHeading>
      <Styled.InnerWrapper>
        {isWideScreen ? <Promotions /> : null}
        {cartServiceMessage ? (
          <InlinedAside content={cartServiceMessage} />
        ) : null}
        <DiscountCodeEntry />
        {discountCode ? <DiscountTags discountCode={discountCode} /> : null}
        <Amounts amounts={amounts} />
      </Styled.InnerWrapper>
      {urls.checkout && !testIsFree(amounts?.subtotal ?? '') ? (
        <>
          <Button
            href={urls.checkout}
            isLink={true}
            variant={[ButtonVariant.FullWidth, ButtonVariant.Primary]}
          >
            Go to checkout
          </Button>
          {isQuickPayEnabled ? <BasketExpressCheckout /> : null}
        </>
      ) : null}
    </Styled.OuterWrapper>
  );
};
